import React from 'react';
import { createBrowserHistory } from 'history';
import { Navbar, NavbarBrand, Nav, NavItem, Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import './Header.scss';
import MainNavBar from './MainNavBar';
import ProspectsModal from '../layout/ProspectsModal';
import PicksModal from '../layout/PicksModal';
import { USERS, USERS_STEPS, STATIC } from '../../Views/ConstPaths';

//Presentational component to show the Header which includes the secondary nav at the top and the main tabbed nav below it.

//Bootstrap notes:
// "container": responsive, fixed-width. max-width changes at each breakpoint. https://getbootstrap.com/docs/5.0/layout/containers/
// With BS 5, don't need an "ml-auto" class on Nav to push all the way to the right
//Will need to add toggler functions if we want to collapse the menu on smaller screen sizes.

function Header(props) {
  const {
    client,
    provider,
    userType, //to mark whether beta or not (shows different home page for beta)
    studyParticipant,
    picks,
    prospects,
    onLogout
  } = props;

  const HOME = "/";
  const LOGIN_URL = USERS + "/" + USERS_STEPS.LOGIN; //GET_STARTED + "/" + GET_STARTED_STEPS.USERNAME;
  const PROVIDER_URL = USERS + "/" + USERS_STEPS.PRACTITIONER_VIEW; //GET_STARTED + "/" + GET_STARTED_STEPS.NAMES;
  const CREATE_URL = USERS + "/" + USERS_STEPS.CREATE;
  const UPDATE_CLIENT_URL = USERS + "/" + USERS_STEPS.UPDATE_CLIENT;

  const history = createBrowserHistory();
  // console.log("rendering Header, on route: " + history.location.pathname);
  
  const mockLogout = () => {
    window.alert("logging you out");
  }

  let inEval = true;
  if (history.location.pathname === "/" || history.location.pathname.startsWith(USERS) || history.location.pathname.startsWith(STATIC)){
    inEval = false;
  }

  let clientURL = "";
  if (!provider){
    clientURL = LOGIN_URL;
  }
  else if (client){
    clientURL = UPDATE_CLIENT_URL;
  }

  //use raw markup for navbar instead of Navbar component, so we can style the "container" to have a background color
  return(
    <>
    <nav className="navbar">
      <div className={"container-fluid aa-header-container " + (inEval ? "aa-header-color-eval" : "aa-header-color-reg")}>
        <span>
          <NavbarBrand 
            href={HOME + (userType ? '?user=' + userType : '') + (studyParticipant ? '?studyParticipant=' + studyParticipant : '')}>
            <img 
              src="/images/AccessNavigatorlogo_horiz.png" 
              // src="/images/Accessnavigator_finallogo-01.png" 
              alt="Access Navigator logo"
            />
            <sup> beta</sup>
          </NavbarBrand>
          {/* { inEval ? <span> &gt; Do an Eval</span> : null } */}
        </span>
        <Nav className="align-items-center">
          { inEval ? 
          <NavItem>
            <div className="aa-stacked-widget"><PicksModal 
              picks={picks}
            />
            </div>
            <div className="aa-stacked-widget"><ProspectsModal 
              prospects={prospects}
            />
            </div>
          </NavItem>
          : null
          }
          <NavItem>
            <NavLink to={clientURL} className={(studyParticipant || !provider || !client) ? "nav-link disabled" : "nav-link"}>
              <span className="fa fa-universal-access fa-lg"></span>
              <div>{client && client.alias ? client.alias : 'the client'}</div>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to={provider ? PROVIDER_URL : LOGIN_URL} className={studyParticipant ? "nav-link disabled" : "nav-link"}>
              <span className="fa fa-user fa-lg"></span>
              <div>{provider && provider.alias ? provider.alias : "you"}</div>
            </NavLink>
          </NavItem>
          <NavItem>
            { provider 
              ?
              <Button onClick={onLogout} className={studyParticipant ? "nav-link btn disabled" : " btn btn-primary btn-sm"}>
                Logout
              </Button>
              :
              <NavLink to={LOGIN_URL} className={studyParticipant ? "nav-link btn disabled" : " btn btn-primary btn-sm"}>
                <div>Login</div>
              </NavLink>
            }
          </NavItem>
          <NavItem>
            <NavLink to={CREATE_URL} className={studyParticipant ? "nav-link btn disabled" : "btn btn-primary btn-sm"}>
                <div>Sign Up</div>
            </NavLink>
          </NavItem>
        </Nav>
      </div>
    </nav>
    { inEval ? <MainNavBar /> : null }
    </>
  );
}

export default Header;
